import React from "react";
import {
	StyleSheet,
} from "react-native";

import { useResources } from "@aetonix/hooks";
import Heading from "ae-base/Base/Heading";
import BlockView from "ae-base/Base/BlockView";

import Style from "ae-style";

const styles = StyleSheet.create({
	itemView: {
		marginTop: Style.layout.marginLarge,
	},
});

export default function ItemView(props) {
	const {
		localize,
	} = useResources();

	var children = props.children;
	var schema = props.schema;
	var description = localize(schema.description);
	var screen = props.screen;

	return (
		<BlockView style={styles.itemView}>
			<Heading title={description} screen={screen} />
			{children}
		</BlockView>
	);
}
